'use client'

import { Chip, Spacer, Cell } from '@vinted/web-ui'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { FeedbackFilterType, clickEvent } from '@marketplace-web/profile/profile-feedback-data'

type Props = {
  selectedFeedbackFilterType: FeedbackFilterType
  showFilters?: boolean
  onClick: (feedbackFilterType: FeedbackFilterType) => void
}

const FeedbackFilters = ({ selectedFeedbackFilterType, showFilters, onClick }: Props) => {
  const translate = useTranslate('user.feedback.filters')
  const { track } = useTracking()

  const getCurrentTargetElement = (feedbackFilterType: FeedbackFilterType) => {
    switch (feedbackFilterType) {
      case FeedbackFilterType.Auto:
        return 'automatic_reviews'
      case FeedbackFilterType.Members:
        return 'member_reviews'
      default:
        return 'all_reviews'
    }
  }

  const handleClick = (feedbackFilterType: FeedbackFilterType) => () => {
    track(
      clickEvent({
        target: getCurrentTargetElement(feedbackFilterType),
        screen: 'user_profile',
      }),
    )
    onClick(feedbackFilterType)
  }

  if (!showFilters) return null

  return (
    <Cell>
      <div className="u-flexbox">
        <SeparatedList separator={<Spacer orientation="vertical" />}>
          <Chip
            activated={selectedFeedbackFilterType === FeedbackFilterType.All}
            text={translate('all')}
            textType="subtitle"
            onClick={handleClick(FeedbackFilterType.All)}
            radius="round"
          />
          <Chip
            activated={selectedFeedbackFilterType === FeedbackFilterType.Members}
            text={translate('members')}
            textType="subtitle"
            onClick={handleClick(FeedbackFilterType.Members)}
            radius="round"
          />
          <Chip
            activated={selectedFeedbackFilterType === FeedbackFilterType.Auto}
            text={translate('auto')}
            textType="subtitle"
            onClick={handleClick(FeedbackFilterType.Auto)}
            radius="round"
          />
        </SeparatedList>
      </div>
    </Cell>
  )
}

export default FeedbackFilters
